import { render, staticRenderFns } from "./ReportCategories.vue?vue&type=template&id=54514dad&scoped=true"
import script from "./ReportCategories.vue?vue&type=script&lang=js"
export * from "./ReportCategories.vue?vue&type=script&lang=js"
import style0 from "./ReportCategories.vue?vue&type=style&index=0&id=54514dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54514dad",
  null
  
)

export default component.exports